/**
 * Route for `affiliate-leaderboard-manual-widget`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AffiliateLeaderboardManualWidgetPage } from "../features/affiliate-leaderboard-manual-widget/AffiliateLeaderboardManualWidgetPage";

export const affiliateLeaderboardManualWidgetRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/affiliate-leaderboard-manual-widget",
	component: AffiliateLeaderboardManualWidgetPage,
});

export default affiliateLeaderboardManualWidgetRoute;
